<template>
  <div
    class="mb-5 position-relative d-flex align-items-center justify-content-center"
    :style="{
      height: '765px',
      width: 'calc(100% + 12%)',
      marginLeft: '-6%',
      marginRight: '-6%',
      marginTop: '-6%',
      backgroundImage: 'var(--frame-report-bg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    }"
  >
    <div class="row w-100 px-5">
      <!-- Project Title LeftSection -->
      <div class="col-md-4">
        <div class="mb-5">
          <div
            class="mb-4"
            style="
              max-width: 200px;
              height: 50px;
              margin-bottom: 200px !important;
              background-image: var(--logo-image-white);
              background-size: contain;
              background-repeat: no-repeat;
              background-position: left;
            "
          ></div>
          <h1
            class="text-white mb-4"
            style="
              font-size: 36px;
              line-height: 1.2;
              max-width: 100%;
              white-space: pre-line;
            "
          >
            {{ $t(`project.previewAndReport.reportTypes.title`) }}
          </h1>
          <div class="bg-white mb-4" style="height: 1px; width: 80%"></div>
          <div class="mb-2">
            <span
              class="text-white"
              style="font-size: 20px; line-height: 1.2"
              >{{ projectData?.project_name || "N/A" }}</span
            >
          </div>
        </div>
      </div>
      <!-- Project Title Right Section -->
      <div class="col-md-8">
        <div
          class="position-relative h-100"
          style="min-height: 200px; width: 100%; margin: 0 auto"
        >
          <PreviewCanvasComponent v-if="includeSections.screenshot">
            <template #footer>
              <div
                v-if="resolvedNoteText"
                class="text-white mt-2"
                style="font-size: 12px; line-height: 1.4"
              >
                {{ resolvedNoteText }}
              </div>
            </template>
          </PreviewCanvasComponent>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import type { Project } from "@/types/projectTypes";
import PreviewCanvasComponent from "@/components/PreviewCanvasComponent.vue";

export default defineComponent({
  name: "ProjectTitleSection",
  components: {
    PreviewCanvasComponent,
  },
  props: {
    projectData: {
      type: Object as PropType<Project | null>,
      required: true,
    },
    includeSections: {
      type: Object as PropType<Record<string, boolean>>,
      required: true,
    },
    reportType: {
      type: String,
      required: true,
    },
  },
  computed: {
    resolvedNoteText(): string {
      const key = `project.previewAndReport.reportTypes.${this.reportType}.note_screenshot`;
      const value = (this.$t(key) as unknown as string) || "";
      const trimmed = String(value).trim();
      // Hide if translation missing (vue-i18n returns the key) or empty
      if (!trimmed || trimmed === key) {
        return "";
      }
      return trimmed;
    },
  },
});
</script>
